import { getToken } from '../Context/User.context';
import API from './index';

export const get = (flightId: number) => API.get(`/delay/findByFlight?flightId=${flightId}`, {headers: { "Authorization": `Bearer ${getToken()}`}});

export const add = (delay: any) => API.post('/delay', delay, {headers: { "Authorization": `Bearer ${getToken()}`}});

export const del = (id: number) => API.delete(`/delay/${id}`, {headers: { "Authorization": `Bearer ${getToken()}`}});

export const getType = () => API.get('/delayType', {headers: { "Authorization": `Bearer ${getToken()}`}});